// Generated by ReScript, PLEASE EDIT WITH CARE


var wrapperStyle = {
  display: "block",
  position: "relative"
};

var menuStyle = {
  background: "white",
  left: "unset",
  position: "absolute",
  top: "unset",
  width: "100%",
  zIndex: "1",
  borderRadius: "0 0 0.8rem 0.8rem",
  boxShadow: "0 0.6rem 1rem -0.4rem gray"
};

var menuStyleAuthenticated = {
  background: "white",
  bottom: "4.4rem",
  left: "unset",
  position: "absolute",
  top: "unset",
  width: "100%",
  zIndex: "1",
  borderRadius: "0.8rem 0.8rem 0 0",
  boxShadow: "0 0.6rem 1rem -0.4rem gray"
};

var wrapperStyleFareEstimate = {
  display: "block",
  position: "relative"
};

var menuStyleFareEstimate = {
  background: "white",
  left: "0rem",
  position: "absolute",
  top: "unset",
  width: "100%",
  zIndex: "1",
  borderRadius: "0 0 0.8rem 0.8rem",
  boxShadow: "0 0.6rem 1rem -0.4rem gray"
};

export {
  wrapperStyle ,
  menuStyle ,
  menuStyleAuthenticated ,
  wrapperStyleFareEstimate ,
  menuStyleFareEstimate ,
}
/* No side effect */
